module.exports = __webpack_public_path__ + "static/media/fst.1f5c88a7.jpg";